export default __webpack_public_path__ + "static/media/1.6e1a7fdb.png";